import { useContext, useEffect, useState, useCallback, useRef } from 'react';
import { SolanaContext } from '../contexts/solanaContext';
import {
  Connection,
  PublicKey,
  Transaction,
  SystemProgram,
  LAMPORTS_PER_SOL,
  TransactionInstruction,
  SYSVAR_RENT_PUBKEY,
  SYSVAR_CLOCK_PUBKEY,
  Keypair
} from '@solana/web3.js';
import { TOKEN_PROGRAM_ID,ASSOCIATED_TOKEN_PROGRAM_ID, getAssociatedTokenAddress, createTransferInstruction, getAccountTypeOfMintType, createAssociatedTokenAccount, createAssociatedTokenAccountInstruction, TOKEN_2022_PROGRAM_ID } from '@solana/spl-token';
import idl from "../components/ABI/idl.json";
import store from "../components/ABI/Store.json";
import FoodGathering from "../components/ABI/FoodGathering.json"; 
import bossFight from "../components/ABI/bossFight.json";
import kingdomofants from "../components/ABI/kingdomofants.json";
import levelGround from "../components/ABI/levelGround.json";
import task from "../components/ABI/task.json";
import workforce from "../components/ABI/workforce.json";
import chestHandler from "../components/ABI/chest_handler.json";

import * as anchor from "@project-serum/anchor";
import { Program, AnchorProvider, web3, utils } from '@project-serum/anchor';
import {
	findMasterEditionPda,
	findMetadataPda,
	mplTokenMetadata,
	MPL_TOKEN_METADATA_PROGRAM_ID,
} from "@metaplex-foundation/mpl-token-metadata";
import { createUmi } from "@metaplex-foundation/umi-bundle-defaults";
import { publicKey } from "@metaplex-foundation/umi";
import { walletAdapterIdentity } from "@metaplex-foundation/umi-signer-wallet-adapters";
import {
  Orao,
  networkStateAccountAddress,
  randomnessAccountAddress,
  FulfillBuilder,
  InitBuilder,
} from "@orao-network/solana-vrf";
import { Buffer } from 'buffer';
import { useDispatch } from 'react-redux';
import { setAntCoinBalanceStore, setAntFoodBalanceStore, setChestCommonBalanceStore, setChestLegendaryBalanceStore, setChestUnCommonBalanceStore, setLevelingPotionBalanceStore,  setChestRareBalanceStore, setChestUltraRareBalanceStore, setStakedNftsStore, setStakedNftLoading, setStakedNftError, setBossedNftsStore, setBossedNftError, setBossedNftLoading,setTaskedNftsStore, setTaskedNftLoading, setTaskedNftError  } from '../store/appSlice';
import { tokenProgram } from '@metaplex-foundation/js';
window.Buffer = Buffer;
// const { Buffer } = require('buffer');
const opts = {
  preflightCommitment:"processed",
};
const alchemyApiKey = process.env.REACT_APP_ALCHEMY_API_KEY;
// const RPC_URL = `https://solana-mainnet.g.alchemy.com/v2/${alchemyApiKey}`;
const RPC_URL = `https://solana-devnet.g.alchemy.com/v2/${alchemyApiKey}`;
const connection = new Connection(RPC_URL,'confirmed');
const programID = new PublicKey(idl.metadata.address);
const gatheringProgramID = new PublicKey(FoodGathering.metadata.address);
const storeProgramID = new PublicKey(store.metadata.address);
const bossFightProgramID = new PublicKey(bossFight.metadata.address);
const kingdomofantsProgramID = new PublicKey(kingdomofants.metadata.address);
const levelGroundProgramID = new PublicKey(levelGround.metadata.address);
const taskProgramID = new PublicKey(task.metadata.address);
const workforceProgramID = new PublicKey(workforce.metadata.address);
const chestHandlerProgramID = new PublicKey(chestHandler.metadata.address);

const SHOP_HANDLER_PROGRAM_ID = new PublicKey('F9yxVrxz6Ex5zsgoxtge2w4Am4NnPuWYrmNNxEtwJoJh');
const PURSE_BUY_HANDLER_PROGRAM_ID = new PublicKey('F9yxVrxz6Ex5zsgoxtge2w4Am4NnPuWYrmNNxEtwJoJh');
// const YOUR_PROGRAM_ID = new PublicKey('BthBhjXZpaF8X9s2YvJjuSkKA8UyhJD5wuazAKts6N6E');

const useSolanaWeb3 = () => {
  const dispatch = useDispatch()
  const { wallet } = useContext(SolanaContext);

  const lastFetchTimeRef = useRef(Date.now());
  const connected = wallet.connected;
  const [antCoinBalance, setAntCoinBalance] = useState(undefined);
  const [antFoodBalance, setAntFoodBalance] = useState(undefined);
  const [chestCommonBalance, setChestCommonBalance] = useState(0);
  const [chestUnCommonBalance, setChestUnCommonBalance] = useState(0);
  const [chestRareBalance, setChestRareBalance] = useState(0);
  const [chestUltraRareBalance, setChestUltraRareBalance] = useState(0);
  const [chestLegendaryBalance, setChestLegendaryBalance] = useState(0);
  const [levelingPotionBalance, setLevelingPotionBalance] = useState(0);
  const [minterAccount, setMinterAccount] = useState(null);
  const [globalStateAccount, setGlobalStateAccount] = useState(null);
  const [workforceGlobalStateAccount, setWorkforceGlobalStateAccount] = useState(null);
  const [levelGroundGlobalStateAccount, setLevelGroundGlobalStateAccount] = useState(null);
  const [bossFightGlobalStateAccount, setBossFightGlobalStateAccount] = useState(null);
  const [taskGlobalStateAccount, setTaskGlobalStateAccount] = useState(null);

  const [basicBatchAccount, setBasicBatchAccount] = useState(null);
  const [vaultAccount, setVaultAccount] = useState(null);
  const [lastFetched, setLastFetched] = useState(0);


  const disconnect = () => {
    wallet.disconnect();
  };

  const getProvider = () => {
    const provider = new AnchorProvider(
      connection,
      wallet,
      opts.preflightCommitment
    );
    return provider;
  };

  // updated
  const buyTokenFromShop = async (tokenMintAddress, amount, div, price) => {
    if (!wallet.connected) {
      console.error('Wallet is not connected');
      return;
    }

    const provider = getProvider();
    const program = new Program(store, storeProgramID, provider);
    const transaction = new Transaction();
    
    const token = new PublicKey(tokenMintAddress);

    const tokenAccount = await getAssociatedTokenAddress(
      token,
      wallet.publicKey
    );

    // Check if the associated token account exists
    const tokenAccountInfo = await provider.connection.getAccountInfo(tokenAccount);

    if (!tokenAccountInfo) {
      transaction.add(
        createAssociatedTokenAccountInstruction(
            wallet.publicKey,
            tokenAccount,
            wallet.publicKey,
            token,
            TOKEN_PROGRAM_ID,
            ASSOCIATED_TOKEN_PROGRAM_ID
        )
      );
    }

    const [tokenVaultAccount, tokenVaultAccountBump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_TOKEN_VAULT_SEED),
        token.toBuffer()
      ],
      program.programId
    );

    const [tokenPrice, tokenPriceBump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_TOKEN_PRICE),
        token.toBuffer()
      ],
      program.programId
    );

    const [vault, vaultBump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(
          process.env.REACT_APP_TOKEN_VAULT_SEED,
        )
      ],
      program.programId
    );

    const [globalState, globalStateBump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_GLOBAL_STATE_SEED),
      ],
      program.programId
    );

    const priceSolFeed = new PublicKey("J83w4HKfqxwcq3BEMMkPFSppX3gqekLyLJBexebFVkix");

    const tx = program.instruction.buyToken(
      new anchor.BN(amount  * price),
      new anchor.BN(div),
      {
        accounts: {
          user: wallet.publicKey,
          vault: vault,
          globalState,
          token,
          userTokenAccount:tokenAccount,
          tokenVaultAccount,
          tokenPrice,
          priceSolFeed,
          tokenProgram: TOKEN_PROGRAM_ID,
          systemProgram: SystemProgram.programId,
          clock: SYSVAR_CLOCK_PUBKEY
        }
      }
    );
    transaction.add(tx);

    // Set the fee payer to the sender's public key
    transaction.feePayer = wallet.publicKey;;
    // Get the recent blockhash
    const recentBlockhash = (await connection.getRecentBlockhash()).blockhash;
    // Sign the transaction
    transaction.recentBlockhash = recentBlockhash;
    // transaction.partialSign(mint);
    const signedTransaction = await wallet.signTransaction(transaction);

    // Send the signed transaction
    try{
      await connection.sendRawTransaction(signedTransaction.serialize());
      await fetchAllBalances()
    } catch(err){
      console.log('err in usesolanaweb3', err)
      throw err;
    }
  };

  const buyRandomTokenFromPurse = async (amount, div, price) => {
    console.log("sfsdfs", amount, div, price);
    const provider = getProvider();
    const program = new Program(store, storeProgramID, provider);
    const transaction = new Transaction();

    const tokens = [process.env.REACT_APP_CHEST_COMMON, process.env.REACT_APP_CHEST_UNCOMMON,process.env.REACT_APP_CHEST_RARE,process.env.REACT_APP_CHEST_ULTRARARE,process.env.REACT_APP_CHEST_LEGENDARY];

    let tokenAccounts = [];
    let tokenVaultAccounts = [];

    for (let i = 0; i<5; i++) {
      const token = new PublicKey(tokens[i]);

      const tokenAccount = await getAssociatedTokenAddress(
        token,
        wallet.publicKey
      );
      tokenAccounts.push(tokenAccount);
  
      // Check if the associated token account exists
      const tokenAccountInfo = await provider.connection.getAccountInfo(tokenAccount);
  
      if (!tokenAccountInfo) {
        transaction.add(
          createAssociatedTokenAccountInstruction(
              wallet.publicKey,
              tokenAccount,
              wallet.publicKey,
              token,
              TOKEN_PROGRAM_ID,
              ASSOCIATED_TOKEN_PROGRAM_ID
          )
        );
      }
      const [tokenVaultAccount, tokenVaultAccountBump] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_TOKEN_VAULT_SEED),
          token.toBuffer()
        ],
        program.programId
      );

      tokenVaultAccounts.push(tokenVaultAccount);
    }
    const [vault, vaultBump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(
          process.env.REACT_APP_TOKEN_VAULT_SEED,
        )
      ],
      program.programId
    );
    console.log("vault", vault.toString());

    const [globalState, globalStateBump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_GLOBAL_STATE_SEED)
      ],
      program.programId
    );
    console.log("globalState", globalState.toString());


    const [userState, userStateBump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_USER_STATE_SEED),
        wallet.publicKey.toBuffer()
      ],
      program.programId
    );
    console.log("userState", userState.toString());

    const force = Keypair.generate().publicKey;
    let random = randomnessAccountAddress(force.toBuffer());
    const vrf = new Orao(provider);
    const networkState = await vrf.getNetworkState()
    const treasury = networkState.config.treasury;
    const token = new PublicKey(tokens[0]);
    const [tokenPrice, tokenPriceBump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_TOKEN_PRICE),
        token.toBuffer()
      ],
      program.programId
    );
   
    const priceSolFeed = new PublicKey("J83w4HKfqxwcq3BEMMkPFSppX3gqekLyLJBexebFVkix");

    const buy_tx = program.instruction.buyChest(
      [...force.toBuffer()],
      new anchor.BN(amount  * price),
      new anchor.BN(div),
      {
        accounts: {
          user: wallet.publicKey,
          globalState,
          vault,
          userState,
          token,
          tokenPrice,
          random,
          treasury,
          config: networkStateAccountAddress(),
          vrf: vrf.programId,
          priceSolFeed,
          tokenProgram: TOKEN_PROGRAM_ID,
          systemProgram: SystemProgram.programId,
        }
      }
    );
    transaction.add(buy_tx);

    // Set the fee payer to the sender's public key
    transaction.feePayer = wallet.publicKey;;
    // Get the recent blockhash
    const recentBlockhash = (await connection.getRecentBlockhash()).blockhash;
    // Sign the transaction
    transaction.recentBlockhash = recentBlockhash;
    // transaction.partialSign(mint);
    const signedTransaction = await wallet.signTransaction(transaction);

    try {
      // Send the signed transaction
      await connection.sendRawTransaction(signedTransaction.serialize());
      await delay(2000);
      const userStateData = await program.account.userState.fetch(userState);
      console.log("userStateData->", userStateData);

      const randomness = await vrf.waitFulfilled(userStateData.force);
      console.log(randomness);

      if(randomness.fulfilled()[0]){
        console.log("sfsdf", randomness.fulfilled()[0]);
        await program.rpc.claimChest(
          randomness.fulfilled()[0],
          {
            accounts: {
              user: wallet.publicKey,
              globalState,
              userState,
              common: tokens[0],
              userCommonAccount: tokenAccounts[0],
              commonVaultAccount:tokenVaultAccounts[0],
    
              uncommon: tokens[1],
              userUncommonAccount: tokenAccounts[1],
              uncommonVaultAccount:tokenVaultAccounts[1],
          
              rare: tokens[2],
              userRareAccount: tokenAccounts[2],
              rareVaultAccount:tokenVaultAccounts[2],
    
              ultrarare: tokens[3],
              userUltrarareAccount: tokenAccounts[3],
              ultrarareVaultAccount:tokenVaultAccounts[3],
    
              legendary: tokens[4],
              userLegendaryAccount: tokenAccounts[4],
              legendaryVaultAccount:tokenVaultAccounts[4],

              random,
    
              tokenProgram: TOKEN_PROGRAM_ID,
              systemProgram: SystemProgram.programId,
            }
          }
        );

        const userStateData1 = await program.account.userState.fetch(userState);
      console.log("userStateData1->", userStateData1);
      console.log("userStateData1->", Number(userStateData1.rand));

      }
    } catch (error) {
      console.log(error);
    }
    
  };
  // updated
  const handleWorkforceStake = async(antInfo, imageUri,value) => {
    const provider = getProvider();
    const program = new Program(workforce, workforceProgramID, provider);

    const depositAmount = value * (10 ** 6);

    const nftMint = new PublicKey(antInfo);

    const nftTokenAccount = await getAssociatedTokenAddress(
      nftMint,
      wallet.publicKey
    );

    const [basicAntInfoAccount, _bump1] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_ANT_STATE_SEED),
        wallet.publicKey.toBuffer(),
        nftMint.toBuffer()
      ],
      kingdomofantsProgramID
    );

    const [stakeStateInfoAccount, _bump2] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_STATE_STATE_SEED),
        wallet.publicKey.toBuffer()
      ],
      kingdomofantsProgramID
    );

    const antCoin = new PublicKey(process.env.REACT_APP_ANT_COIN);
    const ownerAntcTokenAccount = await getAssociatedTokenAddress(
      antCoin,
      wallet.publicKey
    );

    const [workforceTokenVaultAccount, workforcTokenVaultBump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_TOKEN_VAULT_SEED),
        antCoin.toBuffer(),
      ],
      workforceProgramID
    );

    const [tokenVaultAccount, tokenVaultBump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_TOKEN_VAULT_SEED),
        antCoin.toBuffer(),
      ],
      workforceProgramID
    );

    const tx1 = program.instruction.stakeNft(
      imageUri,
      new anchor.BN(value),
      {
        accounts: {
          minterKey: wallet.publicKey,
          workforceGlobalState: workforceGlobalStateAccount,
          globalState: globalStateAccount,
          nftMint,
          nftTokenAccount,
          antStateInfo:basicAntInfoAccount,
          stakedStateInfo: stakeStateInfoAccount,
          tokenProgram: TOKEN_PROGRAM_ID,
          systemProgram: SystemProgram.programId,
          rent: SYSVAR_RENT_PUBKEY,
          clock: SYSVAR_CLOCK_PUBKEY,
          kingdomofantsProgram: kingdomofantsProgramID 
        }
      }
    );

    const tx2 = program.instruction.depositToken(
      new anchor.BN(depositAmount),
      {
        accounts: {
          owner: wallet.publicKey,
          workforceGlobalState: workforceGlobalStateAccount,
          tokenMint: antCoin,
          tokenVaultAccount: tokenVaultAccount,
          tokenOwnerAccount: ownerAntcTokenAccount,
          globalState: globalStateAccount,
          nftMint,
          nftTokenAccount,
          antStateInfo: basicAntInfoAccount,
          tokenProgram: TOKEN_PROGRAM_ID,
          systemProgram: SystemProgram.programId,
          kingdomofantsProgram: kingdomofantsProgramID 
        },
    });
    const transaction = new Transaction().add(tx1).add(tx2);
    // Set the fee payer to the sender's public key
    transaction.feePayer = wallet.publicKey;;

    // Get the recent blockhash
    const recentBlockhash = (await connection.getRecentBlockhash()).blockhash;

    // Sign the transaction
    transaction.recentBlockhash = recentBlockhash;
    // transaction.partialSign(mint);
    const signedTransaction = await wallet.signTransaction(transaction);
    // Send the signed transaction
    const tx = await connection.sendRawTransaction(signedTransaction.serialize());
  }

  const handleAssignedNfts = async() => {
    const provider = getProvider();
    const program = new Program(idl, programID, provider);

    const [stakeStateInfoAccount, _bump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_STATE_STATE_SEED),
        wallet.publicKey.toBuffer()
      ],
      kingdomofantsProgramID
    );

    const stakedStateInfo = await program.account.stakedNftOfUser.fetch(stakeStateInfoAccount);
    return stakedStateInfo.nfts;
   
  }
  // updated
  const fetchAssignedNfts = async() => {
    const provider = getProvider();
    const program = new Program(kingdomofants, kingdomofantsProgramID, provider);
    try{
      dispatch(setStakedNftLoading(true))
      const [stakeStateInfoAccount, _bump] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_STATE_STATE_SEED),
          wallet.publicKey.toBuffer()
        ],
        kingdomofantsProgramID
      );
  
      const stakedStateInfo = await program.account.stakedNftOfUser.fetch(stakeStateInfoAccount);
      await Promise.all(stakedStateInfo.nfts.map((nft, index) => {
        stakedStateInfo.nfts[index].address = nft.address.toString()
      }))
      dispatch(setStakedNftsStore(stakedStateInfo.nfts))
      dispatch(setStakedNftError(null))
    }catch(err){
      dispatch(setStakedNftError(err.toString()))
    }finally{
      dispatch(setStakedNftLoading(false))
    }
  }

  const fetchBossedNfts = async() => {
    const provider = getProvider();
    const program = new Program(bossFight, bossFightProgramID, provider);
    try{
      dispatch(setBossedNftLoading(true))
      const [bossNftsOfUser, _2] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_BOSS_SEED),
          wallet.publicKey.toBuffer()
        ],
        program.programId
      );
  
      const bossedStateInfo = await program.account.bossNfTsOfUser.fetch(bossNftsOfUser);
      await Promise.all(bossedStateInfo.nfts.map((nft, index) => {
        bossedStateInfo.nfts[index].address = nft.address.toString()
      }))
      dispatch(setBossedNftsStore(bossedStateInfo.nfts))
      dispatch(setBossedNftError(null))
    }catch(err){
      dispatch(setBossedNftError(err.toString()))
    }finally{
      dispatch(setBossedNftLoading(false))
    }
  }

  const fetchTaskedNfts = async() => {
    const provider = getProvider();
    const program = new Program(task, taskProgramID, provider);
    try{
      dispatch(setTaskedNftLoading(true))
      const [taskNftsOfUser, _1] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_TASK_SEED),
          wallet.publicKey.toBuffer()
        ],
        program.programId
      );
      const taskedStateInfo = await program.account.taskNfTsOfUser.fetch(taskNftsOfUser);
      let nfts = [];
      for(let i = 0; i< taskedStateInfo.nfts.length; i++) {
        const [taskNftInfo, _2] = await anchor.web3.PublicKey.findProgramAddress(
          [
            Buffer.from(process.env.REACT_APP_TASK_SEED),
            taskedStateInfo.nfts[i].address.toBuffer()
          ],
          program.programId
        );

        const taskNftInfoData = await program.account.taskNftInfo.fetch(taskNftInfo);
        nfts.push({
          address: taskedStateInfo.nfts[i].address.toString(),
          image:taskedStateInfo.nfts[i].image,
          claimed:taskNftInfoData.claimed,
        })
      }

      dispatch(setTaskedNftsStore(nfts))
      dispatch(setTaskedNftError(null))
    }catch(err){
      dispatch(setTaskedNftError(err.toString()))
    }finally{
      dispatch(setTaskedNftLoading(false))
    }
  }
  // updated
  const handleUnStakeNFT = async(address) => {
    const provider = getProvider();
    const program = new Program(workforce, workforceProgramID, provider);

    const nftMint = new PublicKey(address);
    const antCoin = new PublicKey(process.env.REACT_APP_ANT_COIN);

    const nftTokenAccount = await getAssociatedTokenAddress(
      nftMint,
      wallet.publicKey
    );

    const [basicAntInfoAccount, _bump1] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_ANT_STATE_SEED),
        wallet.publicKey.toBuffer(),
        nftMint.toBuffer()
      ],
      kingdomofantsProgramID
    );

    const [stakeStateInfoAccount, _bump2] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_STATE_STATE_SEED),
        wallet.publicKey.toBuffer()
      ],
      kingdomofantsProgramID
    );
   

    const ownerAntcTokenAccount = await getAssociatedTokenAddress(
      antCoin,
      wallet.publicKey
    );

    const [tokenVaultAccount, tokenVaultBump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_TOKEN_VAULT_SEED),
        antCoin.toBuffer(),
      ],
      workforceProgramID
    );

    await program.rpc.unstakeNft(
      {
        accounts: {
          minterKey: wallet.publicKey,
          workforceGlobalState: workforceGlobalStateAccount,
          globalState: globalStateAccount,
          tokenMint: antCoin,
          tokenVaultAccount: tokenVaultAccount,
          tokenOwnerAccount: ownerAntcTokenAccount,
          nftMint,
          nftTokenAccount,
          antStateInfo:basicAntInfoAccount,
          stakedStateInfo: stakeStateInfoAccount,
          tokenProgram: TOKEN_PROGRAM_ID,
          associatedTokenProgram: ASSOCIATED_TOKEN_PROGRAM_ID,
          systemProgram: SystemProgram.programId,
          clock: SYSVAR_CLOCK_PUBKEY,
          kingdomofantsProgram: kingdomofantsProgramID
        }
      }
    );
  }
  // updated
  const handleLevelingGroundStake = async(address, imageUri) => {
    const provider = getProvider();
    const program = new Program(levelGround, levelGroundProgramID, provider);

    const nftMint = new PublicKey(address);

    const nftTokenAccount = await getAssociatedTokenAddress(
      nftMint,
      wallet.publicKey
    );

    const antCoin = new PublicKey(process.env.REACT_APP_ANT_COIN);
    const tokenOwnerAccountForAntc = await getAssociatedTokenAddress(
      antCoin,
      wallet.publicKey
    );
    const [basicAntInfoAccount, _bump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_ANT_STATE_SEED),
        wallet.publicKey.toBuffer(),
        nftMint.toBuffer()
      ],
      kingdomofantsProgramID
    );

    const [stakeStateInfoAccount, _bump2] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_STATE_STATE_SEED),
        wallet.publicKey.toBuffer()
      ],
      kingdomofantsProgramID
    );


    try {
      await program.rpc.levelGroundNft(
        imageUri,
        {
        accounts: {
          owner: wallet.publicKey,
          levelGroundGlobalState: levelGroundGlobalStateAccount,
          globalState: globalStateAccount,
          nftMint,
          nftTokenAccount,
          antStateInfo: basicAntInfoAccount,
          stakedStateInfo: stakeStateInfoAccount,
          tokenForLevel: antCoin,
          tokenOwnerAccountForAntc: tokenOwnerAccountForAntc,
          tokenProgram: TOKEN_PROGRAM_ID,
          systemProgram: SystemProgram.programId,
          clock: SYSVAR_CLOCK_PUBKEY,
          kingdomofantsProgram: kingdomofantsProgramID
        }
      });
    } catch (error) {
      console.log(error);
    }
   
  }
  // updated
  const handleUnLevelingGroundStake = async(address) => {

    const provider = getProvider();
    const program = new Program(levelGround, levelGroundProgramID, provider);

    const nftMint = new PublicKey(address);
    const nftTokenAccount = await getAssociatedTokenAddress(
      nftMint,
      wallet.publicKey
    );
    const antCoin = new PublicKey(process.env.REACT_APP_ANT_COIN);
    const tokenOwnerAccountForAntc = await getAssociatedTokenAddress(
      antCoin,
      wallet.publicKey
    )
    const [basicAntInfoAccount, _bump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_ANT_STATE_SEED),
        wallet.publicKey.toBuffer(),
        nftMint.toBuffer()
      ],
      kingdomofantsProgramID
    );

    const [stakeStateInfoAccount, _bump2] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_STATE_STATE_SEED),
        wallet.publicKey.toBuffer()
      ],
      kingdomofantsProgramID
    );
   

    const tx = await program.rpc.unLevelGroundNft({
      accounts: {
        owner: wallet.publicKey,
        levelGroundGlobalState: levelGroundGlobalStateAccount,
        globalState: globalStateAccount,
        nftMint,
        nftTokenAccount,
        antStateInfo: basicAntInfoAccount,
        stakedStateInfo: stakeStateInfoAccount,
        tokenForLevel: antCoin,
        tokenOwnerAccountForAntc: tokenOwnerAccountForAntc,
        tokenProgram: TOKEN_PROGRAM_ID,
        systemProgram: SystemProgram.programId,
        clock: SYSVAR_CLOCK_PUBKEY,
        kingdomofantsProgram: kingdomofantsProgramID
      }
    });
    const kingdomofantsProgram = new Program(kingdomofants, kingdomofantsProgramID, provider);
    const basicAntInfoAccountContent = await kingdomofantsProgram.account.antState.fetch(basicAntInfoAccount);
    console.log("ant state account  ", basicAntInfoAccountContent);
    const stakedStateInfoData = await kingdomofantsProgram.account.stakedNftOfUser.fetch(stakeStateInfoAccount);
    console.log("stakedStateInfoData ", stakedStateInfoData);
  }

  // updated
  const handleBasicANTMint = async() => {
    try {
      const provider = getProvider();
      const program = new Program(kingdomofants, kingdomofantsProgramID, provider);

      // Create your instructions for mintBasicAnt
      const batchIndex = 1;
      const mintMethod = false;
      const metadata = {
        name: "Basic Worker ANT",
        symbol: "ANTS",
        uri: "https://lavender-holy-egret-893.mypinata.cloud/ipfs/QmWsYC3fCyxWb9yBGNTKMfz9QtpApEcWKHhAzCN4StBgvT",
      };

      const mint = Keypair.generate();

      // Derive the associated token address account for the mint
      const associatedTokenAccount = await getAssociatedTokenAddress(
        mint.publicKey,
        wallet.publicKey
      );

      const umi = createUmi(RPC_URL)
      .use(walletAdapterIdentity(wallet))
      .use(mplTokenMetadata());

      // derive the metadata account
      let metadataAccount = findMetadataPda(umi, {
        mint: publicKey(mint.publicKey),
      })[0];

      //derive the master edition pda
      let masterEditionAccount = findMasterEditionPda(umi, {
        mint: publicKey(mint.publicKey),
      })[0];

      const [basicAntInfoAccount, _] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_ANT_STATE_SEED),
          wallet.publicKey.toBuffer(),
          mint.publicKey.toBuffer()
        ],
        kingdomofantsProgramID
      );
      const [stakeStateInfoAccount, _bump] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_STATE_STATE_SEED),
          wallet.publicKey.toBuffer()
        ],
        kingdomofantsProgramID
      );

      const priceFeed = new PublicKey("J83w4HKfqxwcq3BEMMkPFSppX3gqekLyLJBexebFVkix");

      const mintBasicAntInstruction = program.instruction.mintBasicAnt(
        batchIndex, mintMethod, metadata.name, metadata.symbol, metadata.uri,
        {
          accounts: {
            user: wallet.publicKey,
            globalState: globalStateAccount,
            nftMint: mint.publicKey,
            userNftTokenAccount:associatedTokenAccount,
            nftMetadataAccount:metadataAccount,
            nftMasterEditionAccount:masterEditionAccount,
            tokenProgram:TOKEN_PROGRAM_ID,
            associatedTokenProgram: ASSOCIATED_TOKEN_PROGRAM_ID,
            tokenMetadataProgram: MPL_TOKEN_METADATA_PROGRAM_ID,
            systemProgram: SystemProgram.programId,
            rent: SYSVAR_RENT_PUBKEY
          },
        },); // Add your parameters here

      // Create your instructions for setMintBasicAntSol
      const setMintBasicAntSolInstruction = program.instruction.setMintBasicAntSolPrice(
        batchIndex,
        {
        accounts: {
            user: wallet.publicKey,
            globalState: globalStateAccount,
            vault: vaultAccount,
            basicBatch: basicBatchAccount,
            nftMint: mint.publicKey,
            basicAntInfo: basicAntInfoAccount,
            priceFeed,
            stakedStateInfo: stakeStateInfoAccount,
            systemProgram: SystemProgram.programId,
        },
      }); 
      // Create a transaction that contains both instructions
      const transaction = new Transaction().add(mintBasicAntInstruction).add(setMintBasicAntSolInstruction);

      // Set the fee payer to the sender's public key
      transaction.feePayer = wallet.publicKey;;

      // Get the recent blockhash
      const recentBlockhash = (await connection.getRecentBlockhash()).blockhash;

      // Sign the transaction
      transaction.recentBlockhash = recentBlockhash;
      transaction.partialSign(mint);

      const signedTransaction = await wallet.signTransaction(transaction);
      console.log("signedTransaction->", signedTransaction);
      // Send the signed transaction
      const tx = await connection.sendRawTransaction(signedTransaction.serialize());
      console.log("mint_tx->", tx);
    } catch (error) {
      console.log(error);
    }
  }
  // updated
  const handlePremiumANTMint = async(index) => {
    const provider = getProvider();
    const program = new Program(kingdomofants, kingdomofantsProgramID, provider);
    const antFood = new PublicKey(process.env.REACT_APP_ANT_FOOD);

    const minterAntcAccount = await getAssociatedTokenAddress(
      antFood,
      wallet.publicKey
    );

    const mint = Keypair.generate();

    // Derive the associated token address account for the mint
    const associatedTokenAccount = await getAssociatedTokenAddress(
      mint.publicKey,
      wallet.publicKey
    );

    const umi = createUmi(RPC_URL)
    .use(walletAdapterIdentity(wallet))
    .use(mplTokenMetadata());

    // derive the metadata account
    let metadataAccount = findMetadataPda(umi, {
      mint: publicKey(mint.publicKey),
    })[0];

    //derive the master edition pda
    let masterEditionAccount = findMasterEditionPda(umi, {
      mint: publicKey(mint.publicKey),
    })[0];

    const batchIndex = 1;
    const batchIndexBuffer = Buffer.alloc(4); // Allocate a buffer of 4 bytes
    batchIndexBuffer.writeUInt32LE(batchIndex); // Write the batch index as a little-endian 32-bit unsigned integer
    
    const [premiumBatchAccount, _] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_PREMIUM_BATCH_SEED),
        batchIndexBuffer
      ],
      kingdomofantsProgramID
    );

    const [premiumAntInfoAccount, _bump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_ANT_STATE_SEED),
        wallet.publicKey.toBuffer(),
        mint.publicKey.toBuffer()
      ],
      kingdomofantsProgramID
    );

    const [stakeStateInfoAccount, _bump2] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_STATE_STATE_SEED),
        wallet.publicKey.toBuffer()
      ],
      kingdomofantsProgramID
    );


    try {
      const batchIndex = 1;
      const metadata = {
        name:`Premium Worker ANT ${index}`,
        symbol: `ANTS`,
        uri: `https://lavender-holy-egret-893.mypinata.cloud/ipfs/Qmdq1EUL2cwRXhVHAQ7KNBcfcYW6LKTm7Z1HBNkhaU1Bna/${index}.json`,
      };

      // Create your instructions for mintBasicAnt
      const mintPremiumAntInstruction = program.instruction.mintPremiumAnt(
        batchIndex,index, metadata.name, metadata.symbol, metadata.uri,
        {
        accounts: {
          user: wallet.publicKey,
          globalState: globalStateAccount,
          premiumBatch: premiumBatchAccount,
          nftMint: mint.publicKey,
          userNftTokenAccount:associatedTokenAccount,
          nftMetadataAccount:metadataAccount,
          nftMasterEditionAccount:masterEditionAccount,
          tokenProgram:TOKEN_PROGRAM_ID,
          associatedTokenProgram: ASSOCIATED_TOKEN_PROGRAM_ID,
          tokenMetadataProgram: MPL_TOKEN_METADATA_PROGRAM_ID,
          systemProgram: SystemProgram.programId,
          rent: SYSVAR_RENT_PUBKEY
        },
      });

    // Create your instructions for setMintBasicAntSol
    const setMintPremiumAntWithFoodTokenInstruction = program.instruction.setMintPremiumAntWithFoodToken(
      batchIndex,
      {
      accounts: {
          user: wallet.publicKey,
          globalState: globalStateAccount,
          premiumBatch: premiumBatchAccount,
          nftMint: mint.publicKey,
          premiumAntInfo: premiumAntInfoAccount,
          antFoodToken: antFood,
          userAntFoodTokenAccount:minterAntcAccount,
          stakedStateInfo: stakeStateInfoAccount,
          tokenProgram: TOKEN_PROGRAM_ID,
          associatedTokenProgram: ASSOCIATED_TOKEN_PROGRAM_ID,
          systemProgram: SystemProgram.programId,
          rent: SYSVAR_RENT_PUBKEY
      },
    }); // Add your parameters here

    // Create a transaction that contains both instructions
    const transaction = new Transaction().add(mintPremiumAntInstruction).add(setMintPremiumAntWithFoodTokenInstruction);

    // Set the fee payer to the sender's public key
    transaction.feePayer = wallet.publicKey;;

    // Get the recent blockhash
    const recentBlockhash = (await connection.getRecentBlockhash()).blockhash;

    // Sign the transaction
    transaction.recentBlockhash = recentBlockhash;
    transaction.partialSign(mint);
    const signedTransaction = await wallet.signTransaction(transaction);
    // Send the signed transaction
    const tx = await connection.sendRawTransaction(signedTransaction.serialize());
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  // updated
  const fectchANTStateData = async(address) => {
    const provider = getProvider();
    const program = new Program(kingdomofants, kingdomofantsProgramID, provider);
    const nftMint = new PublicKey(address);
    const [AntInfoAccount, _bump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_ANT_STATE_SEED),
        wallet.publicKey.toBuffer(),
        nftMint.toBuffer()
      ],
      kingdomofantsProgramID
    );

    const AntInfoAccountContent = await program.account.antState.fetch(AntInfoAccount);
    return AntInfoAccountContent;
  }
  // updated
  const fetchBasicBatchInfo = async() => {
    const provider = getProvider();
    const program = new Program(kingdomofants, kingdomofantsProgramID, provider);

    if(basicBatchAccount){
      const basicBatchAccountContent = await program.account.basicBatch.fetch(basicBatchAccount);
      return basicBatchAccountContent;
    } else {
      return null;
    }
  }
  // updated
  const fetchPremiumBatchInfo = async() => {
    const provider = getProvider();
    const program = new Program(kingdomofants, kingdomofantsProgramID, provider);
    const batchIndex = process.env.REACT_APP_CURRENT_PREMIUM_BATCH_INDEX;
    
    const batchIndexBuffer = Buffer.alloc(4); // Allocate a buffer of 4 bytes
    batchIndexBuffer.writeUInt32LE(batchIndex); // Write the batch index as a little-endian 32-bit unsigned integer
    
    const [premiumBatchAccount, _] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_PREMIUM_BATCH_SEED),
        batchIndexBuffer
      ],
      program.programId
    );


    const premiumBatchAccountContent = await program.account.premiumBatch.fetch(premiumBatchAccount);
    return premiumBatchAccountContent;
  }

  const upgradeAntLevelWithLevelingPotion = async(address, potion_amount) => {
    const provider = getProvider();
    const program = new Program(kingdomofants, kingdomofantsProgramID, provider);

    const nftMint = new PublicKey(address);
    const antCoin = new PublicKey(process.env.REACT_APP_ANT_COIN);

    const userAntCoinAccount = await getAssociatedTokenAddress(
      antCoin,
      wallet.publicKey
    );
    const levelingPotionToken = new PublicKey(process.env.REACT_APP_LEVELING_POTION);
    const userLevelingPotionTokenAccount = await getAssociatedTokenAddress(
      levelingPotionToken,
      wallet.publicKey
    );

    const [basicAntInfoAccount, _] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_ANT_STATE_SEED),
        wallet.publicKey.toBuffer(),
        nftMint.toBuffer()
      ],
      kingdomofantsProgramID
    );
    try {
      await program.rpc.upgradeBasicAnt(
        new anchor.BN(potion_amount * 10 ** 6),
        {
          accounts: {
            user: wallet.publicKey,
            globalState: globalStateAccount,
            nftMint,
            basicAntInfo: basicAntInfoAccount,
            antCoin,
            userAntCoinAccount,
            levelingPotionToken,
            userLevelingPotionTokenAccount,
            tokenProgram: TOKEN_PROGRAM_ID,
            systemProgram: SystemProgram.programId,
            rent: SYSVAR_RENT_PUBKEY
          }
        }
      );
    } catch (error) {
      console.log(error);
    }
    
  }

  const fetchBlockchainData = async() => {
    await fetchAllBalances()
  }

  const gatheringStake = async(amount) => {
    const provider = getProvider();
    const program = new Program(FoodGathering, gatheringProgramID, provider);
    const antCoin = new PublicKey(process.env.REACT_APP_ANT_COIN);

    const [globalStateForGathering, globalStateForGatheringBump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from("GLOBAL-STATE-SEED"),
      ],
      program.programId
    )

    const [stakedInfo, stakeInfoBump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from("STAKED-INFO-SEED"),
        wallet.publicKey.toBuffer()
      ],
      program.programId
    );

    const [antCoinVaultAccount, antCoinVaultAccountBump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from("TOKEN-VAULT-SEED"),
        antCoin.toBuffer()
      ],
      program.programId
    );

    const userAntCoinAccount = await getAssociatedTokenAddress(
      antCoin,
      wallet.publicKey
    );


    let stakedAmount = amount * (10 ** 6);

    const tx = await program.rpc.stake(
      new anchor.BN(stakedAmount),
      {
        accounts: {
          user: wallet.publicKey,
          globalState: globalStateForGathering,
          stakedInfo,
          antCoin,
          antCoinVaultAccount,
          userAntCoinAccount,
          tokenProgram: TOKEN_PROGRAM_ID,
          systemProgram: SystemProgram.programId,
          rent: SYSVAR_RENT_PUBKEY
        }
      }
    );
  }

  const gatheringUnStake = async(amount) => {
    const provider = getProvider();
    const program = new Program(FoodGathering, gatheringProgramID, provider);
    const antCoin = new PublicKey(process.env.REACT_APP_ANT_COIN);
    const antFood = new PublicKey(process.env.REACT_APP_ANT_FOOD);

    const [globalStateForGathering, globalStateForGatheringBump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from("GLOBAL-STATE-SEED"),
      ],
      program.programId
    )

    const [stakedInfo, stakeInfoBump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from("STAKED-INFO-SEED"),
        wallet.publicKey.toBuffer()
      ],
      program.programId
    );

    const [antCoinVaultAccount, antCoinVaultAccountBump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from("TOKEN-VAULT-SEED"),
        antCoin.toBuffer()
      ],
      program.programId
    );

    const userAntCoinAccount = await getAssociatedTokenAddress(
      antCoin,
      wallet.publicKey
    );

    const [antFoodTokenVaultAccount,_] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_TOKEN_VAULT_SEED),
        antFood.toBuffer()
      ],
      program.programId
    );

    const userAntFoodTokenAccount = await getAssociatedTokenAddress(
      antFood,
      wallet.publicKey
    );

    try {
      const tx = await program.rpc.unstake(
        {
          accounts: {
            user: wallet.publicKey,
            globalState: globalStateForGathering,
            stakedInfo,
            antCoin,
            antCoinVaultAccount,
            userAntCoinAccount,
            antFoodToken: antFood,
            antFoodTokenVaultAccount,
            userAntFoodTokenAccount,
            tokenProgram: TOKEN_PROGRAM_ID,
            systemProgram: SystemProgram.programId,
          }
        }
      );
    } catch (error) {
      console.log(error);
    }
  
  }

  const chestOpenHandlerRPG = async() => {
    const provider = getProvider();
    const program = new Program(idl, programID, provider);

    const force = Keypair.generate().publicKey.toBuffer();
    const random = randomnessAccountAddress(force);
    const vrf = new Orao(provider);
    const networkState = await vrf.getNetworkState()
    const treasury = networkState.config.treasury;

    try {
      const tx = await program.rpc.chestOpenHandlerRpg(
        [...force],
        {
          accounts: {
            user: wallet.publicKey,
            random: random,
            treasury: treasury,
            config: networkStateAccountAddress(),
            vrf: vrf.programId,
            systemProgram: SystemProgram.programId,
            tokenProgram: TOKEN_PROGRAM_ID
          }
        }
      );
      try{
        const randomness = await vrf.waitFulfilled(force);
        console.log("Your randomness is " + randomness.fulfilled()[0]);  
      }catch(err){
        console.log(err, 'errr')
      }
      
    } catch (error) {
      console.log(error);
    }
  }
  // updated
  const chestOpenHandler = async(item) => {
    let res = {
      token:0,
      amount:0
    };

    const provider = getProvider();              
 
    const program = new Program(chestHandler, chestHandlerProgramID, provider);

    let tokenForChest = null;
    let vaultAccountForChest = null;
    let vaultAccountForChestBump = 0;
    let tokenOwnerAccountForChest = null;
    let transaction = new Transaction();
    let lotteryTicket = new PublicKey(process.env.REACT_APP_LOTTERY_TICKET);
    const [lotteryTicketAccount, _lotteryTicketBump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_TOKEN_VAULT_SEED),
        lotteryTicket.toBuffer()
      ],
      chestHandlerProgramID
    );

    let userLotteryTicketAccount = await getAssociatedTokenAddress(
      lotteryTicket,
      wallet.publicKey
    );

    // Check if the associated token account exists
    const associatedLotteryTicketTokenAccountInfo = await provider.connection.getAccountInfo(userLotteryTicketAccount);
    if (!associatedLotteryTicketTokenAccountInfo) {
  
      transaction.add(
        createAssociatedTokenAccountInstruction(
            wallet.publicKey,
            userLotteryTicketAccount,
            wallet.publicKey,
            lotteryTicket,
            TOKEN_PROGRAM_ID,
            ASSOCIATED_TOKEN_PROGRAM_ID
        )
      );
    }

    const levelingPotion = new PublicKey(process.env.REACT_APP_LEVELING_POTION);
    const [levelingPotionAccount, _levelingPotionbump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_TOKEN_VAULT_SEED),
        levelingPotion.toBuffer()
      ],
      chestHandlerProgramID
    );
    const userLevelingPotionAccount = await getAssociatedTokenAddress(
      levelingPotion,
      wallet.publicKey,
    );

    // Check if the associated token account exists
    const associatedLevelingPotionTokenAccountInfo = await provider.connection.getAccountInfo(userLevelingPotionAccount);
    if (!associatedLevelingPotionTokenAccountInfo) {
      transaction.add(
        createAssociatedTokenAccountInstruction(
            wallet.publicKey,
            userLevelingPotionAccount,
            wallet.publicKey,
            levelingPotion,
            TOKEN_PROGRAM_ID,
            ASSOCIATED_TOKEN_PROGRAM_ID
        )
      );
    }

    const antFood = new PublicKey(process.env.REACT_APP_ANT_FOOD);
    const [antFoodAccount, antFoodBump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_TOKEN_VAULT_SEED),
        antFood.toBuffer()
      ],
      chestHandlerProgramID
    );
    const userAntFoodAccount = await getAssociatedTokenAddress(
      antFood,
      wallet.publicKey,
    );

    // Check if the associated token account exists
    const associatedAntFoodAccountInfo = await provider.connection.getAccountInfo(userAntFoodAccount);

    if (!associatedAntFoodAccountInfo) {
      transaction.add(
        createAssociatedTokenAccountInstruction(
            wallet.publicKey,
            userAntFoodAccount,
            wallet.publicKey,
            antFood,
            TOKEN_PROGRAM_ID,
            ASSOCIATED_TOKEN_PROGRAM_ID
        )
      );
    }

    switch (item) {
      case "item-chest-common":
        tokenForChest = new PublicKey(process.env.REACT_APP_CHEST_COMMON);
        break;
      case "item-chest-uncommon":
        tokenForChest = new PublicKey(process.env.REACT_APP_CHEST_UNCOMMON);
        break;
      case "item-chest-rare":
        tokenForChest = new PublicKey(process.env.REACT_APP_CHEST_RARE);
        break;
      case "item-chest-ultrarare":
        tokenForChest = new PublicKey(process.env.REACT_APP_CHEST_ULTRARARE);
        break;
      case "item-chest-legendary":
        tokenForChest = new PublicKey(process.env.REACT_APP_CHEST_LEGENDARY);
        break;
      default:
        break;
    };

    [vaultAccountForChest, vaultAccountForChestBump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_TOKEN_VAULT_SEED),
        tokenForChest.toBuffer()
      ],
      chestHandlerProgramID
    );

    const [userStateAccount, userStateAccountBump] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_USER_STATE_SEED),
        wallet.publicKey.toBuffer()
      ],
      chestHandlerProgramID
    )

    tokenOwnerAccountForChest = await getAssociatedTokenAddress(
      tokenForChest,
      wallet.publicKey
    );

    const [chestGlobalStateAccount,_] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_GLOBAL_STATE_SEED),
      ],
      program.programId
    );

    try {
      const tx_deposit = program.instruction.chestOpenHandler(
          {
            accounts: {
              user: wallet.publicKey,
              globalState: chestGlobalStateAccount,
              tokenForChest,
              vaultAccountForChest,
              tokenOwnerAccountForChest,
              userState:userStateAccount,
              systemProgram: SystemProgram.programId,
              tokenProgram: TOKEN_PROGRAM_ID,
              clock: SYSVAR_CLOCK_PUBKEY,
            }
          }
      );
      transaction.add(tx_deposit);
      // Set the fee payer to the sender's public key
      transaction.feePayer = wallet.publicKey;;
      // Get the recent blockhash
      const recentBlockhash = (await connection.getRecentBlockhash()).blockhash;
      // Sign the transaction
      transaction.recentBlockhash = recentBlockhash;
      // transaction.partialSign(mint);
      const signedTransaction = await wallet.signTransaction(transaction);

      // // Send the signed transaction
      const tx = await connection.sendRawTransaction(signedTransaction.serialize());

      const tx_claim = await program.rpc.chestOpenClaim(
        {
          accounts: {
            user: wallet.publicKey,
            globalState: chestGlobalStateAccount,
            userState:userStateAccount,
            lotteryTicketToken: lotteryTicket,
            tokenVaultAccountLotteryTicket: lotteryTicketAccount,
            tokenOwnerAccountLotteryTicket: userLotteryTicketAccount,
            levelingPotionToken: levelingPotion,
            tokenVaultAccountLevelingPotion: levelingPotionAccount,
            tokenOwnerAccountLevelingPotion: userLevelingPotionAccount,
            antFoodToken: antFood,
            tokenVaultAccountAntFood: antFoodAccount,
            tokenOwnerAccountAntFood: userAntFoodAccount,
            systemProgram: SystemProgram.programId,
            tokenProgram: TOKEN_PROGRAM_ID,
            clock: SYSVAR_CLOCK_PUBKEY,
          }
        }
      );
      const txData = await connection.getParsedTransaction (tx_claim)
      if(txData?.meta?.innerInstructions?.length>0){
        const splData = txData?.meta?.innerInstructions[0].instructions[0].parsed.info.destination;
        const amount = Number(txData?.meta?.innerInstructions[0].instructions[0].parsed.info.amount)/10**6
        res.amount = amount
        if(splData == userLotteryTicketAccount.toString()) {
          res.token = 1
        } else if(splData == userAntFoodAccount.toString()) {
          res.token = 2
        } else if(splData == userLevelingPotionAccount.toString()) {
      
          res.token = 3
        } 
      }
      return res
    } catch (error) {
      console.log(error);
      return res
    }
  
  }
  // updated
  const handleBossesStake = async(antInfo, imageUri, amount) => {
    const provider = getProvider();
    const program = new Program(bossFight, bossFightProgramID, provider);

    try {
      const nftMint = new PublicKey(antInfo);
      const nftTokenAccount = await getAssociatedTokenAddress(
        nftMint,
        wallet.publicKey
      );
      
      const [bossFightInfo, _1] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_BOSS_SEED),
          nftMint.toBuffer()
        ],
        program.programId
      );
      const [bossNftsOfUser, _2] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_BOSS_SEED),
          wallet.publicKey.toBuffer()
        ],
        program.programId
      );
      const [antStateInfo, _3] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_ANT_STATE_SEED),
          wallet.publicKey.toBuffer(),
          nftMint.toBuffer()
        ],
        kingdomofantsProgramID
      );

      const antCoin = new PublicKey(process.env.REACT_APP_ANT_COIN);

      const tokenOwnerAccountForAntc = await getAssociatedTokenAddress(
        antCoin,
        wallet.publicKey
      );
      const [tokenVaultAccount, tokenVaultBump] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_TOKEN_VAULT_SEED),
          antCoin.toBuffer(),
        ],
        program.programId
      );
  

      const force = Keypair.generate().publicKey.toBuffer();
      const random = randomnessAccountAddress(force);
      const vrf = new Orao(provider);
      const networkState = await vrf.getNetworkState()
      const treasury = networkState.config.treasury;

      const transaction = new Transaction();
      const bossFightTx =  program.instruction.bossFight(
        [...force],
        imageUri,
        {
          accounts: {
            user: wallet.publicKey,
            bossFightGlobalState: bossFightGlobalStateAccount,
            nftMint,
            nftTokenAccount,
            antStateInfo,
            bossFightInfo,
            bossNftsOfUser,
            random,
            treasury,
            config: networkStateAccountAddress(),
            vrf: vrf.programId,
            systemProgram: SystemProgram.programId,
            tokenProgram: TOKEN_PROGRAM_ID,
            kingdomofantsProgram: kingdomofantsProgramID,
          },
        }
      );
     
      const antcAmount = amount * (10 ** 6);
      const depositAntcBossFightTx = program.instruction.depositAntcBossFight(
        new anchor.BN(antcAmount),
        {
          accounts: {
            user: wallet.publicKey,
            bossFightGlobalState: bossFightGlobalStateAccount,
            nftMint,
            bossFightInfo,
            tokenForBoss: antCoin,
            tokenOwnerAccountForAntc,
            tokenVaultAccount,
            systemProgram: SystemProgram.programId,
            tokenProgram: TOKEN_PROGRAM_ID,
            clock: SYSVAR_CLOCK_PUBKEY,
          }
        }
      );
      transaction.add(bossFightTx).add(depositAntcBossFightTx);

      // Set the fee payer to the sender's public key
      transaction.feePayer = wallet.publicKey;;
      // Get the recent blockhash
      const recentBlockhash = (await connection.getRecentBlockhash()).blockhash;
      // Sign the transaction
      transaction.recentBlockhash = recentBlockhash;
      const signedTransaction = await wallet.signTransaction(transaction);

      // Send the signed transaction
      const tx = await connection.sendRawTransaction(signedTransaction.serialize());

      const bossFightInfoData = await program.account.bossFightInfo.fetch(bossFightInfo);
      console.log("bossFightInfoData->", bossFightInfoData);
    } catch (error) {
      console.log(error);
    }
  }
  // updated
  const handleUnBossesStake = async(address) => {
    const provider = getProvider();
    const program = new Program(bossFight, bossFightProgramID, provider);
    const kingdomofantsProgram = new Program(kingdomofants, kingdomofantsProgramID, provider);

    try {
      const nftMint = new PublicKey(address);
      const nftTokenAccount = await getAssociatedTokenAddress(
        nftMint,
        wallet.publicKey
      );
      const [bossFightInfo, _1] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_BOSS_SEED),
          nftMint.toBuffer()
        ],
        program.programId
      );

      const [antStateInfo, _3] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_ANT_STATE_SEED),
          wallet.publicKey.toBuffer(),
          nftMint.toBuffer()
        ],
        kingdomofantsProgramID
      );

      const bossFightInfoData = await program.account.bossFightInfo.fetch(bossFightInfo);
      console.log("bossFightInfoData->", bossFightInfoData);
      const bossFightGlobalStateData = await program.account.bossFightGlobalState.fetch(bossFightGlobalStateAccount);
      console.log("bossFightGlobalStateData->", bossFightGlobalStateData);
      const antStateData = await kingdomofantsProgram.account.antState.fetch(antStateInfo);
      console.log("antStateData->", antStateData);
      const level = Number(antStateData.level);
      console.log("level->", level);

      let div = 1;
      if (level <= Number(bossFightGlobalStateData.catepillarLevel)) {
          div = 1;
      } else if (level <= Number(bossFightGlobalStateData.snailLevel)) {
          div = 2;
      } else if (level <= Number(bossFightGlobalStateData.beetleLevel)) {
          div = 3;
      } else if (level <= Number(bossFightGlobalStateData.snakeLevel)) {
          div = 4;
      } else if (level <= Number(bossFightGlobalStateData.anteaterLevel)) {
          div = 5;
      }

      const force = bossFightInfoData.force;
      const provider = program.provider;
      const vrf = new Orao(provider);
      const networkState = await vrf.getNetworkState();
      const random = randomnessAccountAddress(force);
      const randomness = await vrf.waitFulfilled(force);
      const rand =  randomness.fulfilled();
      const bossIndex = parseInt(rand[0] * 100 / 255) % div + 1;
      console.log("bossIndex->", bossIndex);

      const [boss, _2] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_BOSS_SEED),
          new anchor.BN(bossIndex).toArrayLike(Buffer, 'le', 4),
        ],
        program.programId
      );

      const [bossNftsOfUser, _4] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_BOSS_SEED),
          wallet.publicKey.toBuffer()
        ],
        program.programId
      );

      const antCoin = new PublicKey(process.env.REACT_APP_ANT_COIN);

      const tokenOwnerAccountForAntc = await getAssociatedTokenAddress(
        antCoin,
        wallet.publicKey
      );

      const [tokenVaultAccount, tokenVaultBump] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_TOKEN_VAULT_SEED),
          antCoin.toBuffer(),
        ],
        bossFightProgramID
      );

      const tx = await program.rpc.leaveBossFight(
        bossIndex,
        {
          accounts: {
            user: wallet.publicKey,
            bossFightGlobalState: bossFightGlobalStateAccount,
            globalState: globalStateAccount,
            boss,
            nftMint,
            nftTokenAccount,
            antStateInfo,
            bossFightInfo,
            bossNftsOfUser,
            tokenForBoss: antCoin,
            tokenOwnerAccountForAntc,
            tokenVaultAccount,
            random,
            systemProgram: SystemProgram.programId,
            tokenProgram: TOKEN_PROGRAM_ID,
            clock: SYSVAR_CLOCK_PUBKEY,
            kingdomofantsProgram: kingdomofantsProgramID
          }
        }
      );
    } catch (error) {
      console.log(error);
    }
  }
  // updated
  const handleTasksStake = async(antInfo, imageUri) => {
    try {

      const provider = getProvider();
      const program = new Program(task, taskProgramID, provider);
      const force = Keypair.generate().publicKey;

      const nftMint = new PublicKey(antInfo);
      const nftTokenAccount = await getAssociatedTokenAddress(
        nftMint,
        wallet.publicKey
      );
      
      const [antStateInfo, _1] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_ANT_STATE_SEED),
          wallet.publicKey.toBuffer(),
          nftMint.toBuffer()
        ],
        kingdomofantsProgramID
      );

      const [taskNftInfo, _2] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_TASK_SEED),
          nftMint.toBuffer()
        ],
        taskProgramID
      );

      const antCoin = new PublicKey(process.env.REACT_APP_ANT_COIN);
      const tokenOwnerAccountForAntc = await getAssociatedTokenAddress(
        antCoin,
        wallet.publicKey
      );

      const [taskNftsOfUser, _3] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_TASK_SEED),
          wallet.publicKey.toBuffer()
        ],
        taskProgramID
      );

      const random = randomnessAccountAddress(force.toBuffer());
      const vrf = new Orao(provider);
      const networkState = await vrf.getNetworkState()
      const treasury = networkState.config.treasury;

      const tx = await program.rpc.startTask(
        [...force.toBuffer()],
        imageUri,
        {
          accounts: {
            user: wallet.publicKey,
            taskGlobalState: taskGlobalStateAccount,
            nftMint,
            nftTokenAccount,
            antStateInfo,
            taskNftInfo,
            tokenForTask: antCoin,
            tokenOwnerAccountForAntc,
            taskNftsOfUser,
            random: random,
            treasury: treasury,
            config: networkStateAccountAddress(),
            vrf: vrf.programId,
            systemProgram: SystemProgram.programId,
            tokenProgram: TOKEN_PROGRAM_ID,
            clock: SYSVAR_CLOCK_PUBKEY,
            kingdomofantsProgram: kingdomofantsProgramID
          }
        }
      );

      const taskNftInfoData = await program.account.taskNftInfo.fetch(taskNftInfo);
      const taskNftsOfUserData = await program.account.taskNfTsOfUser.fetch(taskNftsOfUser);
      console.log("taskNftInfoData->", taskNftInfoData);
      console.log("taskNftsOfUserData->", taskNftsOfUserData);
    } catch (error) {
      console.log(error);
    }
  }
  // updated
  const handleClaimRewardTask = async(antInfo) => {
    try {
      const provider = getProvider();
      const program = new Program(task, taskProgramID, provider);
      const kingdomofantsProgram = new Program(kingdomofants, kingdomofantsProgramID, provider);
      const transaction = new Transaction();

      const nftMint = new PublicKey(antInfo);

      const [antStateInfo, _1] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_ANT_STATE_SEED),
          wallet.publicKey.toBuffer(),
          nftMint.toBuffer()
        ],
        kingdomofantsProgramID
      );

      const [taskNftInfo, _2] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_TASK_SEED),
          nftMint.toBuffer()
        ],
        taskProgramID
      );

      const vrf = new Orao(provider);
      const taskNftInfoData = await program.account.taskNftInfo.fetch(taskNftInfo);
      const random = randomnessAccountAddress(taskNftInfoData.force);
      const randomness = await vrf.waitFulfilled(taskNftInfoData.force);
      const rand = randomness.fulfilled()[0];
      
      const antStateInfoData = await kingdomofantsProgram.account.antState.fetch(antStateInfo);
      const level = Number(antStateInfoData.level);

      const globalStateData = await program.account.taskGlobalState.fetch(taskGlobalStateAccount);
     

      let div = 1;
      if (level <= Number(globalStateData.uncommonLevel)) {
          div = 1;
      } else if (level <= Number(globalStateData.rareLevel)) {
          div = 2;
      } else if (level <= Number(globalStateData.ultraLevel)) {
          div = 3;
      } else if (level <= Number(globalStateData.legendaryLevel)) {
          div = 4;
      } else {
          div = 5;
      }

      const tokenIndex = (parseInt(rand * 100 / 255) % div + 1);
      let tokenForTask = null;

      if (tokenIndex == 1) {
        tokenForTask = new PublicKey(process.env.REACT_APP_CHEST_COMMON);
      } else if (tokenIndex == 2) {
        tokenForTask = new PublicKey(process.env.REACT_APP_CHEST_UNCOMMON);
      } else if (tokenIndex == 3) {
        tokenForTask = new PublicKey(process.env.REACT_APP_CHEST_RARE);
      } else if (tokenIndex == 4) {
        tokenForTask = new PublicKey(process.env.REACT_APP_CHEST_ULTRARARE);
      } else if (tokenIndex == 5) {
        tokenForTask = new PublicKey(process.env.REACT_APP_CHEST_LEGENDARY);
      }

      const tokenOwnerAccountForTask = await getAssociatedTokenAddress(
        tokenForTask,
        wallet.publicKey
      );

      // Check if the associated token account exists
      const tokenAccountInfo = await provider.connection.getAccountInfo(tokenOwnerAccountForTask);

      if (!tokenAccountInfo) {
        transaction.add(
          createAssociatedTokenAccountInstruction(
              wallet.publicKey,
              tokenOwnerAccountForTask,
              wallet.publicKey,
              tokenForTask,
              TOKEN_PROGRAM_ID,
              ASSOCIATED_TOKEN_PROGRAM_ID
          )
        );
      }

      const [tokenVaultAccount,_] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_TOKEN_VAULT_SEED),
          tokenForTask.toBuffer()
        ],
        taskProgramID
      );

      const tx = program.instruction.claimPurseFromTask(
        {
          accounts: {
            user: wallet.publicKey,
            taskGlobalState: taskGlobalStateAccount,
            nftMint,
            antStateInfo,
            taskNftInfo,
            tokenForTask,
            tokenOwnerAccountForTask,
            tokenVaultAccount,
            random,
            systemProgram: SystemProgram.programId,
            tokenProgram: TOKEN_PROGRAM_ID,
            clock: SYSVAR_CLOCK_PUBKEY,
            kingdomofantsProgram: kingdomofantsProgramID
          }
        }
      );
      transaction.add(tx);
      // Set the fee payer to the sender's public key
      transaction.feePayer = wallet.publicKey;;
      // Get the recent blockhash
      const recentBlockhash = (await connection.getRecentBlockhash()).blockhash;
      // Sign the transaction
      transaction.recentBlockhash = recentBlockhash;
      console.log(transaction);
      const signedTransaction = await wallet.signTransaction(transaction);

      // Send the signed transaction
      await connection.sendRawTransaction(signedTransaction.serialize());
      await fetchAllBalances()
    } catch (error) {
      console.log(error);
    }
  }

  const handleUnTaskedStake = async(antInfo) => {
    try {
      const provider = getProvider();
      const program = new Program(task, taskProgramID, provider);

      const nftMint = new PublicKey(antInfo);
      const nftTokenAccount = await getAssociatedTokenAddress(
        nftMint,
        wallet.publicKey
      );
      const [taskNftInfo, _2] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_TASK_SEED),
          nftMint.toBuffer()
        ],
        taskProgramID
      );
      const [taskNftsOfUser, _3] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_TASK_SEED),
          wallet.publicKey.toBuffer()
        ],
        taskProgramID
      );
      const tx = await program.rpc.untaskedNft(
        {
          accounts: {
            user: wallet.publicKey,
            taskGlobalState: taskGlobalStateAccount,
            nftMint,
            taskNftInfo,
            taskNftsOfUser,
            nftTokenAccount,
            tokenProgram: TOKEN_PROGRAM_ID,
            systemProgram: SystemProgram.programId,
            clock: SYSVAR_CLOCK_PUBKEY
          }
        }
      );

    } catch (error) {
      console.log(error);
    }
  }

  const getTaskedNFTInfo = async(antInfo) => {
    const provider = getProvider();
    const program = new Program(task, taskProgramID, provider);

    const nftMint = new PublicKey(antInfo[0].address);
    
    const [taskNftInfo, _1] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from(process.env.REACT_APP_TASK_SEED),
        nftMint.toBuffer()
      ],
      taskProgramID
    );

    const data = await program.account.taskNftInfo.fetch(taskNftInfo);
    return data;
 }  
 // updated
  const fetchTokenBalance = async (envVariable) => {
    try {
      const mintAddress = new PublicKey(process.env[envVariable]);
      const tokenAccounts = await connection.getParsedTokenAccountsByOwner(wallet.publicKey, { mint: mintAddress });
      const tokenAccountInfo = tokenAccounts.value.find(accountInfo => accountInfo.account.data.parsed.info.mint === mintAddress.toString());
      if (tokenAccountInfo) {
        const tokenAccountAddress = tokenAccountInfo.pubkey;
        const balance = await connection.getTokenAccountBalance(tokenAccountAddress);
        return balance.value.uiAmount || 0;
      }
      return 0;
    } catch (error) {
      console.error(`Error fetching ${envVariable} balance:`, error);
      return 0;
    }
  };
  // updated
  const fetchAllBalances = async () => {
    const tokens = [
      'REACT_APP_ANT_COIN',
      'REACT_APP_ANT_FOOD',
      'REACT_APP_CHEST_COMMON',
      'REACT_APP_CHEST_UNCOMMON',
      'REACT_APP_CHEST_RARE',
      'REACT_APP_CHEST_ULTRARARE',
      'REACT_APP_CHEST_LEGENDARY',
      'REACT_APP_LEVELING_POTION',
    ];

    const balances = await Promise.all(tokens.map(token => fetchTokenBalance(token)));
    console.log('balances', balances)
    setAntCoinBalance(balances[0]);
    setAntFoodBalance(balances[1]);
    setChestCommonBalance(balances[2]);
    setChestUnCommonBalance(balances[3]);
    setChestRareBalance(balances[4]);
    setChestUltraRareBalance(balances[5]);
    setChestLegendaryBalance(balances[6]);
    setLevelingPotionBalance(balances[7]);

    dispatch(setAntCoinBalanceStore(balances[0]))
    dispatch(setAntFoodBalanceStore(balances[1]))
    dispatch(setChestCommonBalanceStore(balances[2]))
    dispatch(setChestUnCommonBalanceStore(balances[3]))
    dispatch(setChestRareBalanceStore(balances[4]))
    dispatch(setChestUltraRareBalanceStore(balances[5]))
    dispatch(setChestLegendaryBalanceStore(balances[6]))
    dispatch(setLevelingPotionBalanceStore(balances[7]))
  };

  const delay = (ms) => {
      return new Promise(resolve => setTimeout(resolve, ms));
  }

  useEffect(() => {
    const now = Date.now();
    const cooldownPeriod = 20000; // 20 seconds in milliseconds
  
    if (wallet.connected && wallet.publicKey && (now - lastFetched > cooldownPeriod)) {
      fetchAllBalances();
      setLastFetched(now);
    }
  }, [wallet.connected, wallet.publicKey]); // Dependencies

  useEffect(() => {
    const getMinterAccount = async() => {
      try {
        const [minterAccount, _bump] = await anchor.web3.PublicKey.findProgramAddress(
          [
            Buffer.from(process.env.REACT_APP_MINTER_STATE_SEED),
            wallet.publicKey.toBuffer()
          ],
          programID
        );
        setMinterAccount(minterAccount);
      } catch (error) {
        console.log(error);
      }
    }

    const getGlobalStateAccount = async() => {
      try {
        const [globalStateAccount, _bump] = await anchor.web3.PublicKey.findProgramAddress(
          [
            Buffer.from(process.env.REACT_APP_GLOBAL_STATE_SEED),
          ],
          kingdomofantsProgramID
        );
        setGlobalStateAccount(globalStateAccount);

        const [workforceGlobalStateAccount, workforceGlobalStatebump] = await anchor.web3.PublicKey.findProgramAddress(
          [
            Buffer.from(process.env.REACT_APP_GLOBAL_STATE_SEED),
          ],
          workforceProgramID
        );
        setWorkforceGlobalStateAccount(workforceGlobalStateAccount);

        const [levelGroundGlobalStateAccount, levelGroundGlobalStatebump] = await anchor.web3.PublicKey.findProgramAddress(
          [
            Buffer.from(process.env.REACT_APP_GLOBAL_STATE_SEED),
          ],
          levelGroundProgramID
        );
        setLevelGroundGlobalStateAccount(levelGroundGlobalStateAccount);

        const [bossFightGlobalStateAccount, bossFightGlobalStatebump] = await anchor.web3.PublicKey.findProgramAddress(
          [
            Buffer.from(process.env.REACT_APP_GLOBAL_STATE_SEED),
          ],
          bossFightProgramID
        );
        setBossFightGlobalStateAccount(bossFightGlobalStateAccount);

        const [taskGlobalStateAccount, taskGlobalStateBump] = await anchor.web3.PublicKey.findProgramAddress(
          [
            Buffer.from(process.env.REACT_APP_GLOBAL_STATE_SEED),
          ],
          taskProgramID
        );
        setTaskGlobalStateAccount(taskGlobalStateAccount);
      } catch (error) {
        console.log(error);
      }
    }

    const getBasicBatch = async() => {
      try {
        const batchIndex = 1;
        const batchIndexBuffer = Buffer.alloc(4); // Allocate a buffer of 4 bytes
        batchIndexBuffer.writeUInt32LE(batchIndex); // Write the batch index as a little-endian 32-bit unsigned integer
        
        const [basicBatchAccount, basicBatchBump] = await anchor.web3.PublicKey.findProgramAddress(
          [
            Buffer.from(process.env.REACT_APP_BASIC_BATCH_SEED),
            batchIndexBuffer
          ],
          kingdomofantsProgramID
        );
        setBasicBatchAccount(basicBatchAccount);
      } catch (error) {
        console.log(error);
      }
    }

    const getVaultAccount = async() => {
      try {
        const [vaultAccount, _] = await anchor.web3.PublicKey.findProgramAddress(
          [
            Buffer.from(process.env.REACT_APP_VAULT_SEED)
          ],
          kingdomofantsProgramID
        );
        setVaultAccount(vaultAccount);
      } catch (error) {
        console.log(error);
      }
    }

    if(wallet.connected && wallet.publicKey) {
      getMinterAccount();
      getGlobalStateAccount();
      getBasicBatch();
      getVaultAccount();
    }
  },[wallet.connected, wallet.publicKey])

  return {
    wallet,
    connected,
    disconnect,
    antCoinBalance,
    antFoodBalance,
    levelingPotionBalance,
    chestCommonBalance,
    chestUnCommonBalance,
    chestRareBalance,
    chestUltraRareBalance,
    chestLegendaryBalance,
    buyTokenFromShop,
    buyRandomTokenFromPurse,
    handleWorkforceStake,
    fetchBlockchainData,
    handleAssignedNfts,
    handleUnStakeNFT,
    handleBossesStake,
    handleUnBossesStake,
    handleTasksStake,
    handleClaimRewardTask,
    handleUnTaskedStake,
    handleLevelingGroundStake,
    handleUnLevelingGroundStake,
    fectchANTStateData,
    handleBasicANTMint,
    handlePremiumANTMint,
    fetchBasicBatchInfo,
    fetchPremiumBatchInfo,
    upgradeAntLevelWithLevelingPotion,
    gatheringStake,
    gatheringUnStake,
    chestOpenHandlerRPG,
    chestOpenHandler,
    fetchAllBalances,
    fetchAssignedNfts,
    fetchBossedNfts,
    fetchTaskedNfts,
    getTaskedNFTInfo
  };
};

export default useSolanaWeb3;